import { ActionType, createAsyncAction } from 'typesafe-actions';
import { DataFetchingThunkAction } from '../../types';
import { getErrorCustomData } from '../../../../common/errors/CustomFetchApiError';
import { getLoggedInUserData } from '../actions';
import { hideOverlay } from 'Client/redux/header/overlays/actions';
import { OverlayId } from 'Client/components/Overlays/types';

export const unblockUserActions = createAsyncAction(
    '@UNBLOCK_USER/START',
    '@UNBLOCK_USER/SUCCESS',
    '@UNBLOCK_USER/FAILED'
)<undefined, undefined, Error>();

export const unblockUser = (email: string, password: string, overlayId: OverlayId): DataFetchingThunkAction => async (
    dispatch,
    _,
    { apiService, logger }
) => {
    dispatch(unblockUserActions.request());
    try {
        const unblockResult = await apiService.shopApi.unblockUser(email);
        if (unblockResult?.success && unblockResult?.data.success) {
            const authenticationResult = await apiService.shopApi.authenticate(email, password);
            if (!authenticationResult?.success) {
                throw authenticationResult;
            }
            await dispatch(getLoggedInUserData());
            dispatch(unblockUserActions.success());
            dispatch(hideOverlay(overlayId));
            return;
        }

        throw unblockResult;
    } catch (err) {
        logger.error(err, { action: 'apiUnblockUser', ...getErrorCustomData(err) });
        dispatch(unblockUserActions.failure(err));
    }
};

export type UnblockUserActions = ActionType<typeof unblockUserActions>;
